/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useState, useRef } from 'react';

const TypingHeadline = ({ text, speed = 50, delay = 10000 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [iteration, setIteration] = useState(0);
  const [hovered, setHovered] = useState(false);
  const [fading, setFading] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (hovered) return; // Pause on hover

    let i = 0;
    setDisplayedText('');
    const interval = setInterval(() => {
      setDisplayedText(prev => prev + text.charAt(i));
      i++;
      if (i >= text.length) clearInterval(interval);
    }, speed);

    const fadeAndRestart = setTimeout(() => {
      setFading(true);
      setTimeout(() => {
        setFading(false);
        setIteration(prev => prev + 1);
      }, 500); // Fade out duration
    }, delay);

    return () => {
      clearInterval(interval);
      clearTimeout(fadeAndRestart);
    };
  }, [iteration, text, speed, delay, hovered]);

  return (
    <span
      ref={containerRef}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        fontWeight: '600',
        fontSize: '1.25rem',
        color: '#92400E',
        fontFamily: 'Segoe UI, Roboto, sans-serif',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        opacity: fading ? 0 : 1,
        transition: 'opacity 0.5s ease',
        display: 'inline-block',
      }}
    >
      📰{displayedText}
      <span
        style={{
          display: 'inline-block',
          width: '1ch',
          animation: 'blink 1s step-end infinite',
          color: '#92400E',
        }}
      >
        |
      </span>

      {/* Add the keyframes directly in JSX */}
      <style>
        {`
          @keyframes blink {
            from, to { opacity: 0 }
            50% { opacity: 1 }
          }
        `}
      </style>
    </span>
  );
};

export default TypingHeadline;
